var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-app-bar-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-spacer'),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.logout}},[_c('v-icon',[_vm._v("mdi-logout")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }